module.exports = __webpack_public_path__ + "img/icon-caret-right.0e9c7794.svg";